import React, { useState, useEffect } from 'react'
import { useAtomValue } from 'jotai'
import { IconCross, IconCalendarRound } from '../ui'
import uniqid from 'uniqid'
import { Form } from 'react-bootstrap'
import { IFilterDateRange, EDatePickerMode } from '../../types'
import DatePicker from 'react-datepicker'
import dt, { Dayjs } from 'dayjs'
import styled from 'styled-components'
import { reactSelectStyles } from './filterHelpers'
import { ISelectOption } from '../../types/ui'
import Select from 'react-select'
import * as state from '../../states'
import * as helpers from '../../helpers'
import { DATE_PICKER_MODE_OPTIONS } from '../../constants'
import { useTranslation } from 'react-i18next'

// https://reactdatepicker.com/#example-default

const DatePickerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
`

const SelectModeBox = styled.div`
    width: 78px;
`

export const FilterDateRange = (props: IFilterDateRange) => {
	const {
		attr,
		value,
		setValue,
		label,
		placeholder,
		styles = {},
		isClearable = false,
		isDisabled = false,
		filterDate = (date: Date | dt.Dayjs | string) => true,
		highlightDates = [],
		locale = '',
		monthsShown = 1,
		showMonthYearPicker = false,
		isIconRightVisible = false,
		iconRight = <IconCalendarRound size={20}/>
	} = props
	const { t } = useTranslation()
	const key = uniqid()
	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const [showDatePickerMode, setShowDatePickerMode] = useState<ISelectOption<EDatePickerMode> | null>(null)

	const DATE_PICKER_MODE_OPTIONS_TRANS = DATE_PICKER_MODE_OPTIONS(t)

	const setFilterDateRangeValue = (
		a: Date | Dayjs | null,
		b: Date | Dayjs | null
	) => {
		setValue([a ? dt(a).format('YYYY-MM-DD') : '', b ? dt(b).format('YYYY-MM-DD') : ''])
	}

	const switchFilterDateRangeValue = () => {
		const [startDate, endDate] = helpers.getDateRange(showDatePickerMode?.value ?? null)

		setFilterDateRangeValue(startDate, endDate)
	}

	useEffect(() => {
		if (!!showDatePickerMode) {
			switchFilterDateRangeValue()
		}
	}, [showDatePickerMode])

	return (
		<div className="filter-input-cont">
			{label ? <Form.Label className="text-dark" htmlFor={`date-range-${key}`}>{label}</Form.Label> : null}
			{/* show-datepicker-mode switch-select: pre-defined date range intervals */}
			<DatePickerWrapper>
				<SelectModeBox>
					<Select
						inputId={'select-show-datepicker-mode'}
						className="react-select-container"
						placeholder={iconRight}
						isDisabled={isDisabled}
						options={DATE_PICKER_MODE_OPTIONS_TRANS}
						//value={showDatePickerMode}
						// important:: not to change inner state now (no two-way-binding)
						value={null}
						isSearchable={false}
						styles={reactSelectStyles<ISelectOption<EDatePickerMode>, false>(isThemeDark, { menuWidth: '170px' })}
						onChange={(selectedItem) => {
							setShowDatePickerMode(selectedItem)
						}}
					/>
				</SelectModeBox>

				<div className={'src-form position-relative'} style={styles}>
					<DatePicker
						id={`date-range-${key}`}
						className="form-control"
						// selectsDisabledDaysInRange
						selectsRange
						// showMonthDropdown
						// showYearDropdown
						rangeSeparator=" - "
						{...attr}
						placeholderText={placeholder}
						disabled={isDisabled}
						startDate={value[0] && dt(value[0]).isValid() ? dt(value[0]).toDate() : null}
						endDate={value[1] && dt(value[1]).isValid() ? dt(value[1]).toDate() : null}
						onChange={([a, b]) => {
							setShowDatePickerMode(null) // clear showDatePickerMode on DatePickerChange by user (not pre-defined range)
							setFilterDateRangeValue(a, b)
						}}
						dateFormat="dd/MM/yyyy"
						// showWeekNumbers
						filterDate={filterDate}
						highlightDates={highlightDates}
						locale={locale}
						monthsShown={monthsShown}
						showMonthYearPicker={showMonthYearPicker}
					/>
					<div className={'input-buttons bg-transparent position-absolute top-50 translate-middle-y'}>
						{!isDisabled && isClearable && value.some(_ => !!_) ? (
							<i className="icon-cross" onClick={(event) => {
								setShowDatePickerMode(null) // clear showDatePickerMode on DatePickerChange by user (not pre-defined range)
								setFilterDateRangeValue(null, null)
							}}>
								<IconCross/>
							</i>
						) : null}

						{isIconRightVisible ? (
							<>
								<span className="indicator-separator"></span>

								<i className="icon-calendar-round">
									{iconRight}
								</i>
							</>
						) : null}
					</div>
				</div>
			</DatePickerWrapper>
		</div>
	)
}